import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function DifferentiationSection() {
  const benefits = ['Menos chats muertos y vistos sin respuesta', 'Menos regateo innecesario', 'Más decisiones claras (sí o no, pero rápido)', 'Más ventas sin presión ni ansiedad'];
  return <section className="w-full bg-[#F9FAFB] py-20 px-4 sm:px-6 lg:px-8" data-id="element-38">
      <div className="max-w-4xl mx-auto" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-40">
          <h2 className="text-2xl sm:text-3xl font-bold text-[#1A1A1A] mb-6" data-id="element-41">
            ¿Por qué esto funciona si lo que ya intentaste no?
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto leading-relaxed" data-id="element-42">
            Porque no estás comprando "información" teórica. <br data-id="element-43" />
            <span className="font-bold text-[#0B6B3A]" data-id="element-44">
              Estás comprando palabras exactas para situaciones exactas.
            </span>
          </p>
        </motion.div>

        <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100" data-id="element-45">
          <h3 className="text-lg font-semibold text-gray-500 uppercase tracking-wider mb-6 text-center" data-id="element-46">
            El resultado inmediato:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-47">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-center gap-3" data-id="element-48">
                <CheckCircle2 className="w-6 h-6 text-[#0B6B3A] flex-shrink-0" data-id="element-49" />
                <span className="text-lg text-[#1A1A1A] font-medium" data-id="element-50">
                  {benefit}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}